// helpers/resetCanvas.js

/**
 * Wipes out the current canvas, removes background/layers,
 * and resets everything to a fresh state.
 */
export function resetCanvas({
    setUploadedImage,
    setBgImage,
    uploadedImageObj,
    originalBgDataRef,
    layersRef,
    eraserStrokesRef,
    setTopTextInput,
    setBottomTextInput,
    setExtraTextInputs,
    setIsAssetAdded,
    canvasRef,
  }) {
    // 1) Clear the background
    setUploadedImage(null);
    setBgImage(null);
    if (uploadedImageObj) {
      uploadedImageObj.current = null;
    }
    if (originalBgDataRef) {
      originalBgDataRef.current = null;
    }
  
    // 2) Clear layers and eraser strokes
    if (layersRef) {
      layersRef.current = [];
    }
    if (eraserStrokesRef) {
      eraserStrokesRef.current = [];
    }
  
    // 3) Clear text states
    setTopTextInput("");
    setBottomTextInput("");
    setExtraTextInputs([]);
    setIsAssetAdded(false);
  
    // 4) Wipe the canvas
    const canvas = canvasRef?.current;
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  }
  